// extracted by mini-css-extract-plugin
module.exports = {"grid":"SectionContact-module--grid--1ddp7","contact":"SectionContact-module--contact--23eOa","triangle":"SectionContact-module--triangle--QAZ8F"};